export default "{\n    \"restaurant\": \"Restaurant\",\n    \"vendor\": \"Vendor\"\n}\n"